export default "__VITE_ASSET__C$FcuAyJ__";